import React from "react";
import { CentsPalette } from "../../../../../utils/colors";
import { CustomFilledButton } from "../../../common/buttons/CustomFilledButton";
import InputFilter from "./InputFilter";

interface Props {
  placeholder: string
  filterKey: string
  filterTable: () => void
}

const SearchBarFilter: React.FC<Props> = ({ placeholder, filterKey, filterTable }) => {

  return (
    <div className="search-input flex gap-2">
      <InputFilter placeholder={placeholder} filterKey={filterKey} search filterTable={filterTable}/>
      <CustomFilledButton onClick={filterTable} className="!px-2">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.6464 21.3536C20.8417 21.5488 21.1583 21.5488 21.3536 21.3536C21.5488 21.1583 21.5488 20.8417 21.3536 20.6464L20.6464 21.3536ZM17.3235 10.4118C17.3235 14.229 14.229 17.3235 10.4118 17.3235V18.3235C14.7813 18.3235 18.3235 14.7813 18.3235 10.4118H17.3235ZM10.4118 17.3235C6.5945 17.3235 3.5 14.229 3.5 10.4118H2.5C2.5 14.7813 6.04222 18.3235 10.4118 18.3235V17.3235ZM3.5 10.4118C3.5 6.5945 6.5945 3.5 10.4118 3.5V2.5C6.04222 2.5 2.5 6.04222 2.5 10.4118H3.5ZM10.4118 3.5C14.229 3.5 17.3235 6.5945 17.3235 10.4118H18.3235C18.3235 6.04222 14.7813 2.5 10.4118 2.5V3.5ZM15.3523 16.0594L20.6464 21.3536L21.3536 20.6464L16.0594 15.3523L15.3523 16.0594Z" 
            fill={CentsPalette.cents_white}/>
        </svg>
      </CustomFilledButton>
    </div>
  )
}

export default SearchBarFilter;